/**
 * Created by lizj on 2018.6.13.
 */

;(function () {

    SelfProductCtrl.$inject = ['request', '$timeout', 'event'];
    angular
        .module('DSSXAPP')
        .component('selfProduct', {
            template:'<div class="data-admin-component data-admin-self-product"><div class="self-product-title"><h3 class="title">零效果产品</h3><span>店铺切换 <i class="iconfont icon-moreunfold"></i></span><div>过滤中国流量<div></div></div></div><div class="condition-ineffective"><div class="preference-general"><input type="text" placeholder="请输入产品名称" ng-model="vm.d.productName"> <span class="title">无效时长：</span><div class="dropdown dropdown-customize" ng-click="vm.f.toggleDropMenu(\'ineffectiveTimeArr\')"><div class="dropdown-layout dropdown-content" ng-bind="vm.d.timeObj.name"></div><div class="dropdown-layout dropdown-trigger"><div class="dropdown-triangle">&nbsp;</div></div></div><div class="dropdown-menu" ng-show="vm.d.isShowWhereDropMenu === \'ineffectiveTimeArr\'"><ul><li ng-repeat="time in vm.d.ineffectiveTimeArr" ng-bind="time.name" ng-click="vm.f.selectDropMenu(time.val,\'ineffectiveTimeArr\',\'timeObj\')"></li><li class="disabled"><span class="op">≥</span> <input type="text" class="textfield textfield-system" ng-model="vm.d.ineffectiveTime" ng-change="vm.f.limitInputVal()"> <span class="day">天</span> <a class="button-normal button-small" ng-click="vm.f.validatorTime()">确定</a><div class="custom-tip" ng-class="{\'shake\': !vm.d.timeIsValidator}">请输入15-365之间的数字</div></li></ul></div><span class="title">负责人：</span><div class="dropdown dropdown-customize cursor-not-allow"><div class="dropdown-layout dropdown-content" ng-click="vm.f.toggleDropMenu(\'principalArr\')" ng-bind="vm.d.principalObj.name"></div><div class="dropdown-layout dropdown-trigger"><div class="dropdown-triangle">&nbsp;</div></div></div><span class="title">产品分组：</span><div class="dropdown dropdown-customize cursor-not-allow"><div class="dropdown-layout dropdown-content" ng-bind="vm.d.groupObj.name" ng-click="vm.f.toggleDropMenu(\'groupArr\')"></div><div class="dropdown-layout dropdown-trigger"><div class="dropdown-triangle">&nbsp;</div></div></div><a class="button-primary button-medium preference-OK" ng-click="vm.f.search(1)">搜索</a> <a class="button-primary button-medium reset" ng-click="vm.f.reset()">重置数据</a></div><div class="preference-product condition-common"><div class="condition-line condition-line1">更多产品类型： <span class="preference-column preference-column-3"><label class="check2 check"><input type="checkbox" class="checkbox" disabled>&nbsp;<span>橱窗产品</span></label></span></div></div></div><div class="product-ineffective"><div class="chowder-bar util-clearfix"><div class="button-area"><label class="select-all button-normal button-medium"><input type="checkbox" class="checkbox" ng-model="vm.d.isAllChecked" ng-change="vm.f.allChecked()"><span>全选本页</span></label> <button class="multi-select-delete button-normal button-medium" ng-class="{\'disabled\': vm.d.isDisabledBtn}" ng-click="vm.f.soldOutPros()">下架</button> <button class="multi-select-delete button-normal button-medium" ng-class="{\'disabled\': vm.d.isDisabledBtn}" ng-click="vm.f.del()">删除</button></div><div class="pagination pagination-pager util-clearfix" ng-show="!vm.d.pending && !vm.d.searchIsNull"><label class="label">{{vm.c.pagination.currentPage}} / {{vm.f.mathCeil(vm.c.pagination.numberOfData / vm.c.pagination.dataPerPage)}}</label> <span class="pagination-prev pagination-disabled" ng-click="vm.f.loadLastPage()">previous</span> <span class="pagination-next pagination-disabled" ng-click="vm.f.loadNextPage()">next</span></div></div><table class="products-table" border="0" cellspacing="0" cellpadding="0"><tr><th class="products-checkbox align-left" width="5%">&nbsp;</th><th class="product-title align-left" width="20%"><span class="th-title">产品</span></th><th class="products-owner align-left" width="15%"><span class="th-title">负责人</span></th><th class="products-time align-right th-title-order order" width="13%" ng-click="vm.f.sortList(\'invalidTime\')"><span class="th-title">无效时长(天)</span> <span class="ico-triangle ico-triangle-order" ng-class="{\'ico-triangle-order-desc\': vm.d.sortModel === \'desc\',\'ico-triangle-order-asc\': vm.d.sortModel === \'asc\'}"></span></th><th class="products-updated align-center th-title-order" width="12%"><span class="th-title">最近更新时间</span> <span class="ico-triangle ico-triangle-order"></span></th><th class="products-remain align-center th-title-order" width="12%"><span class="th-title" title="根据Alibaba.com商品信息管理规范，该产品即将被下线的倒计时天数。如果该产品为不可自动下架的产品，则该项将显示为\'-\'。">自动下线倒计时（天）</span> <span class="ico-triangle ico-triangle-order default-asc"></span></th><th class="products-action align-center" width="23%"><span class="th-title">操作</span></th></tr><tr class="tip-loading align-center" ng-show="vm.d.pending"><td colspan="7"><img src="../../../../images/common/loading-small.gif"></td></tr><tr class="tip-server-busy align-center" style="display: none;"><td colspan="7">服务器正忙，请稍候再试。</td></tr><tr class="tip-no-data align-center" ng-show="!vm.d.pending && vm.d.searchIsNull"><td colspan="7">对不起，未能查询到符合您要求的产品，建议重新设置查询条件。</td></tr><tr class="product-item" ng-repeat="item in vm.d.list"><td class="products-checkbox align-left"><input class="delete-check" type="checkbox" ng-model="vm.d.deleteObj[item.productId]" ng-change="vm.f.judgeIsDisabledBtn()"></td><td class="products-img align-left"><a><img ng-src="{{item.img}}"></a> <span class="ico-product ico-ps" title="windowProduct"></span><div class="products-name align-left" ng-bind="item.productName"></div></td><td class="products-owner align-left" ng-bind="item.principal"></td><td class="products-time align-right" ng-bind="item.invalidTime"></td><td class="products-updated align-center" ng-bind="item.updateTime"></td><td class="products-remain align-center" ng-bind="item.autoOffLineCountDown"></td><td class="products-action align-center"><a class="action action-abled" href="javascript:void(0);">编辑</a> <a class="action action-abled" href="javascript:void(0);" ng-click="vm.f.delOne(item.productId)">删除</a> <a class="action action-abled" href="javascript:void(0);" ng-show="item.putaway === \'yes\'" ng-click="vm.f.soldOutPro(item.productId)">下架</a> <i class="cursor-not-allow" ng-show="item.putaway === \'no\'">已下架</i> <span class="products-action-p4p"></span></td></tr></table><div style="padding: 20px;"><pagination dataperpage="vm.c.pagination.dataPerPage" numberofdata="vm.c.pagination.numberOfData" numberofshow="vm.c.pagination.numberOfShow" currentpage="vm.c.pagination.currentPage" change-page="vm.f.search(page)"></pagination></div></div><dialog-reset></dialog-reset><dialog-del></dialog-del><dialog-cond-del></dialog-cond-del></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: SelfProductCtrl
        });

    function SelfProductCtrl(request, $timeout, event) {
        this.$onInit = onInit;

        var vm = this;
        var util = DSSX.util;

        vm.c = {
            pagination: {
                dataPerPage: 10, // 每页显示多少条数据
                numberOfData: 0, // 总共有多少条数据
                numberOfShow: 5, // 每次显示多少个页码
                currentPage: 1, // 当前的页码
            }
        }

        vm.d = {
            isShowAbout: false,
            isShowWhereDropMenu: '',
            ineffectiveTimeArr: [
                {name: '大于等于15天', val: 15},
                {name: '大于等于30天', val: 30},
                {name: '大于等于60天', val: 60},
                {name: '大于等于90天', val: 90},
                {name: '大于等于180天', val: 180},
                {name: '大于等于365天', val: 365}
            ],
            ineffectiveTime: null,
            timeIsValidator: true,
            timeObj: {name: '大于等于365天', val: 365},
            principalArr: [
                {name: '全部', val: 'all'},
                {name: '..', val: '..'},
                {name: 'Devin Teng', val: 'Devin Teng'},
                {name: 'Huiyan Zhu', val: 'Huiyan Zhu'},
                {name: 'Su Ying Lau', val: 'Su Ying Lau'},
                {name: 'Yin Jin', val: 'Yin Jin'}
            ],
            principalObj: {name: '全部', val: 'all'},
            groupArr: [
                {name: '所有分组', val: 'all'},
                {name: 'Keyboards', val: 'Keyboards'},
                {name: 'Mice', val: 'Mice'},
                {name: '未分组', val: 'Ungroup'}
            ],
            groupObj: {name: '所有分组', val: 'all'},
            updateTime: '任意时间',
            deleteObj: {},
            isDisabledBtn: true,
            isAllChecked: false,
            list: [],
            pending: true,
            searchIsNull: true,
            productName: '',
            sortBy: 'invalidTime',
            sortModel: 'desc',
            listLen: 0,
            canSearch: true
        };

        vm.f = {
            limitInputVal: limitInputVal,
            toggleDropMenu: toggleDropMenu,
            validatorTime: validatorTime,
            selectDropMenu: selectDropMenu,
            judgeIsDisabledBtn: judgeIsDisabledBtn,
            allChecked: allChecked,
            search: search,
            sortList: sortList,
            soldOutPro: soldOutPro,
            soldOutPros: soldOutPros,
            reset: reset,
            del: del,
            delOne: delOne,
            condDel: condDel,
            mathCeil: mathCeil,
            loadLastPage: loadLastPage,
            loadNextPage: loadNextPage
        };

        function onInit() {
            console.log('[onInit self-product.js]');
            clickWinHideDrop();
            initCalendar();
            initEvent();
            search(1);
            // getProNum();
        }

        //初始化日历控件
        function initCalendar() {
            $('.startTime').showCalendar({
                className: 'strongCalendar',
                thisMonthFontColor: '#0055cc',
                dateHoverBgColor: '#4499ff',
                dateHoverFontColor: '#fff',
                tableBorder: '1px solid #AFAFAF',
                innerBorder: '0px',
                noThisMonthFontColor: '#a499af',
                noThisMonthBgColor: '#efefef',
                weekBgColor: '#fff',
                monthCut: 3,
                dateCut: 2
            });
        }

        function initEvent() {
            event.on('reset-success', function () {
                vm.d.deleteObj = {};
                vm.d.isAllChecked = false;
                judgeIsDisabledBtn();
                search(1);
            });
        }

        //获得15天及以上产品的数量
        function getProNum() {
            var config = {
                page: 1,//页数
                pageCount: 10,//页大小
                productName: vm.d.productName || '',//产品名称
                sortBy: vm.d.sortBy || 'invalidTime',//排序字段：invalidTime: 失效时长
                sortModel: vm.d.sortModel || 'desc',//排序方式，desc：倒序；asc：升序
                statisticsType: 'day',//统计类型：day
                time: 15
            };
            loadListZeroEffectPrd(config)
                .then(function (pro) {
                    vm.d.listLen = pro.products.length;
                })
            ;
        }

        //点击document的时候隐藏下拉菜单
        function clickWinHideDrop() {
            $(document).on('click', function (e) {
                /*当为这几个元素的时候不需要隐藏*/
                if ($('.startTime').triggerTarget(e) || $('.strongCalendar').triggerTarget(e) || $('.dropdown').triggerTarget(e) || $('li.disabled').triggerTarget(e) || $('.menu-tree').triggerTarget(e)) {
                    return;
                }

                $('.strongCalendar').empty().remove();

                $timeout(function () {
                    toggleDropMenu();
                })
            })
        }

        function reset() {
            event.emit('layout.showDialogReset', true);
        }

        function delOne(id) {
            var data = {
                type: true,
                id: id
            };

            event.emit('layout.showDialogDelOne', data);
        }

        function del() {
            if (vm.d.isDisabledBtn) {
                return;
            }

            var data = {
                type: true,
                selectData: vm.d.deleteObj
            };

            event.emit('layout.showDialogDel', data);
        }

        function condDel() {
            search(1, true);
        }

        //下架单个产品
        function soldOutPro(id) {
            var config = {
                ids: [id],
                method: 'shelve'
            };
            updateZeroEffectPrd(config)
        }

        //批量下架产品
        function soldOutPros() {
            if (vm.d.isDisabledBtn) {
                return;
            }

            var deleteObj = vm.d.deleteObj;
            var ids = [];
            var config = {
                ids: [],
                method: 'shelve'
            };

            for (var attr in deleteObj) {
                if (deleteObj.hasOwnProperty(attr)) {
                    if (deleteObj[attr]) {
                        ids.push(attr);
                    }
                }
            }
            config.ids = ids;

            updateZeroEffectPrd(config);
        }

        //对数据进行排序
        function sortList(type) {
            vm.d.sortBy = type;
            vm.d.sortModel = vm.d.sortModel === 'desc' ? 'asc' : 'desc';

            search(1);
        }

        function search(page, isPreviewing) {
            isPreviewing = isPreviewing || false;
            var config = {
                page: page,//页数
                pageCount: vm.c.pagination.dataPerPage,//页大小
                productName: vm.d.productName || '',//产品名称
                sortBy: vm.d.sortBy || 'invalidTime',//排序字段：invalidTime: 失效时长
                sortModel: vm.d.sortModel || 'desc',//排序方式，desc：倒序；asc：升序
                statisticsType: 'day',//统计类型：day
                time: vm.d.timeObj.val
            };
            loadListZeroEffectPrd(config, isPreviewing)
                .then(handleList)
                .then(function (obj) {
                    if (!isPreviewing) {
                        vm.d.list = obj.list;
                    } else {
                        vm.d.listLen = obj.list.length;
                        var data = {
                            type: true,
                            dataLen: obj.list.length,
                            list: [],
                            total: obj.total
                        };
                        data.list.push({key: '无效时长', val: vm.d.timeObj.name, num: vm.d.timeObj.val});
                        data.list.push({key: '产品名称', val: vm.d.productName});
                        event.emit('layout.showDialogCondDel', data);
                    }
                })
            ;
        }

        //更新零效果产品
        function updateZeroEffectPrd(data) {
            return request.post('/usr/api/updateZeroEffectPrd', {}, data, true)
                .then(updateSuc, updateErr)
            ;

            function updateSuc(res) {
                if (res.code === 0) {
                    vm.d.deleteObj = {};
                    vm.d.isAllChecked = false;
                    judgeIsDisabledBtn();
                    search(1);
                }
                ZeroEffectProductTMInterpolator()
            }

            function updateErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'SelfProductCtrl',
                    funcName: 'updateZeroEffectPrd',
                    text: 'SelfProductCtrl fail'
                });
            }
        }

        //列出零效果产品
        function loadListZeroEffectPrd(param, isPreviewing) {
            if (vm.d.canSearch) {
                vm.d.canSearch = false
                isPreviewing = isPreviewing || false;
                if (!isPreviewing) {
                    vm.d.pending = true;
                    vm.d.searchIsNull = false;
                    vm.d.list = [];
                }
                return request.get('/usr/api/listZeroEffectPrd', param, true)
                    .then(loadSuc, loadErr)
                    ;

                function loadSuc(res) {
                    var obj = {
                        products: [],
                        total: 0
                    }
                    vm.d.canSearch = true
                    var products = util.safe(res, 'data.products', []);
                    if (!isPreviewing) {
                        vm.d.pending = false;
                        if (!products.length) {
                            vm.d.searchIsNull = true;
                        }
                    }
                    // 更新分页组件
                    vm.c.pagination.currentPage = param.page
                    vm.c.pagination.numberOfData = res.data.total
                    //
                    vm.d.deleteObj = {}
                    vm.d.isAllChecked = false
                    vm.d.isDisabledBtn = true

                    obj.products = products
                    obj.total = res.data.total
                    return obj;
                }

                function loadErr(err) {
                    DSSX.dialog.err(err, {
                        moduleName: 'SelfProductCtrl',
                        funcName: 'loadListZeroEffectPrd',
                        text: 'SelfProductCtrl fail'
                    });
                    return {
                        products: [],
                        total: 0
                    };
                }
            }
        }

        function handleList(pro) {
            var obj = {
                list: [],
                total: pro.total
            };

            angular.forEach(pro.products, function (v) {
                obj.list.push({
                    productId: v.id,
                    img: v.imgs[0] && v.imgs[0].url,
                    productName: v.productName || '-',
                    principal: '' || '-',
                    invalidTime: v.sampleInfo.zeroEffect.invalidDayTime || '-',
                    updateTime: calcUpdateTime(v.sampleInfo.zeroEffect.invalidDayTime) || '-',
                    autoOffLineCountDown: (365 - v.sampleInfo.zeroEffect.invalidDayTime) || '-',
                    putaway: v.putaway
                })
            });

            return obj;
        }

        function calcUpdateTime(invalidTime) {
            var s = 1e3;
            var minS = 60 * s;
            var hourS = minS * 60;
            var dayS = hourS * 24;
            invalidTime = invalidTime * dayS || 0;
            var curTime = util.getServerCurrentTime().getTime();
            var beginInvalidTime = new Date(curTime - invalidTime);
            var invalidYear = beginInvalidTime.getFullYear();
            var invalidMonth = beginInvalidTime.getMonth() + 1;
            var invalidDay = (Math.floor(beginInvalidTime.getDate() / 8) + 1) * 7;
            var remDay = invalidTime % 5;
            var updateTimeDay = invalidDay - remDay;

            return invalidYear + '-' + invalidMonth + '-' + updateTimeDay;
        }

        //点击全选按钮
        function allChecked() {
            var deleteObj = {};
            var arr = [];
            angular.forEach(vm.d.list, function (v) {
                deleteObj[v.productId] = false;
            });

            for (var attr in deleteObj) {
                if (deleteObj.hasOwnProperty(attr)) {
                    vm.d.deleteObj[attr] = vm.d.isAllChecked;
                    arr.push(vm.d.isAllChecked);
                }
            }
            vm.d.isDisabledBtn = !judgeIsOneTrue(arr);
        }

        //判断时候禁用按钮
        function judgeIsDisabledBtn() {
            var deleteObj = {};
            var arr = [];
            angular.forEach(vm.d.list, function (v) {
                deleteObj[v.productId] = false;
                for (var key in vm.d.deleteObj) {
                    if (vm.d.deleteObj.hasOwnProperty(key)) {
                        if (key === v.productId) {
                            deleteObj[v.productId] = vm.d.deleteObj[key];
                            break;
                        }
                    }
                }
            });

            for (var attr in deleteObj) {
                if (deleteObj.hasOwnProperty(attr)) {
                    arr.push(deleteObj[attr]);
                }
            }

            vm.d.isDisabledBtn = !judgeIsOneTrue(arr);
            vm.d.isAllChecked = judegIsAllTrue(arr);
        }

        //判断时候有一个值为true
        function judgeIsOneTrue(data) {
            return data.some(function (v) {
                return v === true;
            })
        }

        //判断所有的值都为true
        function judegIsAllTrue(data) {
            return data.every(function (v) {
                return v === true;
            })
        }

        //选择下拉菜单
        function selectDropMenu(val, typeArr, type) {
            angular.forEach(vm.d[typeArr], function (v) {
                if (v.val === val) {
                    vm.d[type] = v;
                }
            });
            (typeArr === 'groupArr') || toggleDropMenu();
        }

        //验证输入的无效时间
        function validatorTime() {
            var time = vm.d.ineffectiveTime;

            if (time < 15 || time > 365) {
                vm.d.timeIsValidator = false;

                $timeout(function () {
                    vm.d.timeIsValidator = true;
                }, 500);

                return;
            }

            vm.d.timeObj = {name: '大于等于' + time + '天', val: time};
            toggleDropMenu();
        }

        //切换显示隐藏下拉菜单
        function toggleDropMenu(type) {
            type = type || '';

            if (type === 'groupArr') {
                vm.d.isShowWhereDropMenu = type;
                return;
            }

            if (type && vm.d.isShowWhereDropMenu === type) {
                vm.d.isShowWhereDropMenu = '';
                return;
            }

            vm.d.isShowWhereDropMenu = type;
        }

        //限制input只能输入整数
        function limitInputVal() {
            vm.d.ineffectiveTime = parseInt(vm.d.ineffectiveTime);
        }

        // 实训任务-零效果产品页插入逻辑
        function ZeroEffectProductTMInterpolator() {
            var TM = DSSX.TrainingMission;

            return TM.tryStart(TM.MissionType.ZeroEffectProduct, {bindId: '', bindInfo: ''})
                .then(tryStartTMSuc, tryStartTMErr);

            function tryStartTMSuc(tmc) {
                console.log('[inqChatCtrl] TM tmc: ', tmc);
                // 没有任务需要同步或同步失败
                if (!tmc) {
                    // do something
                }
            }

            function tryStartTMErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'SelfProductCtrl',
                    funcName: 'tryStart',
                    text: '实训任务错误',
                });
                console.log('[TM] tryStartTMErr', err);
            }
        }

        // 上取整
        function mathCeil(num) {
            return Math.ceil(num)
        }

        // 加载上一页数据
        function loadLastPage() {
            if (vm.c.pagination.currentPage > 1) {
                search(vm.c.pagination.currentPage - 1)
            }
        }

        // 加载下一页数据
        function loadNextPage() {
            if (vm.c.pagination.currentPage < mathCeil(vm.c.pagination.numberOfData / vm.c.pagination.dataPerPage)) {
                search(vm.c.pagination.currentPage + 1)
            }
        }

    }

})();